var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 0.5C8.8387 0.5 7.72536 1.04 6.9987 1.89333C6.27203 1.04 5.1587 0.5 3.9987 0.5C1.94536 0.5 0.332031 2.11333 0.332031 4.16667C0.332031 6.68667 2.5987 8.74 6.03203 11.86L6.9987 12.7333L7.96536 11.8533C11.3987 8.74 13.6654 6.68667 13.6654 4.16667C13.6654 2.11333 12.052 0.5 9.9987 0.5ZM7.06536 10.8667L6.9987 10.9333L6.93203 10.8667C3.7587 7.99333 1.66536 6.09333 1.66536 4.16667C1.66536 2.83333 2.66536 1.83333 3.9987 1.83333C5.02536 1.83333 6.02536 2.49333 6.3787 3.40667H7.62536C7.97203 2.49333 8.97203 1.83333 9.9987 1.83333C11.332 1.83333 12.332 2.83333 12.332 4.16667C12.332 6.09333 10.2387 7.99333 7.06536 10.8667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.829dc531dabf18694b30bbdb3baa2812.svg";
export { ForwardRef as ReactComponent };